import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {
    const store = useStore();
    const { commaFormat } = figureFormatter();
    const { getHeader, getFooter } = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, statementData) => {
        var doc = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [40, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(statementData),
            styles: {
                header: {
                    fontSize: 24,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'Reward Point Statement'
            }
        }

        pushIntoTable(doc, statementData)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (statementData) => {
        return [
            {
                text: 'Reward Point Statement',
                style: 'header',
                margin: [0, 0, 5, 5],
                bold: true,
                color: 'black',
                fontSize: 20,
                alignment: 'center',
            },
            {
                margin: [0, 20, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: statementData.party_name ? 'Party Name: ' + statementData.party_name : ''
                            },
                            {
                                text: statementData.report_period ? 'Report Period: ' + statementData.report_period : ''
                            },
                        ]
                    },
                    {
                        alignment: 'right',
                        stack: [
                            {
                                text: `Opening Balance: ${commaFormat(statementData.opening_balance)}`
                            },
                            {
                                text: `Closing Balance: ${commaFormat(statementData.closing_balance)}`
                            }
                        ]
                    },
                ]
            },
            {
                style: 'tableExample',
                margin: [0, 15, 0, 0],
                table: {
                    body: [],
                    widths: ['15%', '17%', '30%', '13%', '13%', '12%']
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const pushIntoTable = (doc, statementData) => {
        const tableItems = statementData.reward_point_log;
        const tableHeader = getTableHeader();
        doc.content[2].table.body.push(tableHeader);
        const openingBalanceRow = getBalanceRow('Opening Balance', statementData.opening_balance);
        doc.content[2].table.body.push(openingBalanceRow);
        tableItems.forEach(item => {
            const rowData = getRowData(item);
            return doc.content[2].table.body.push(rowData);
        });
        const closingBalanceRow = getBalanceRow('Closing Balance', statementData.closing_balance);
        doc.content[2].table.body.push(closingBalanceRow);
    }

    const getBalanceRow = (label, value) => {
        return [
            { text: label, alignment: 'right', colSpan: 5, bold: true },
            '', '', '', '',
            { text: commaFormat(value), alignment: 'right', bold: true },
        ]
    }

    const getTableHeader = () => {
        return [
            { text: 'Date' },
            { text: 'Txn Number' },
            { text: 'Note' },
            { text: 'Points Earned', alignment: 'right' },
            { text: 'Points Redeemed', alignment: 'right' },
            { text: 'Balance', alignment: 'right' },
        ]
    }

    const getRowData = (item) => {
        return [
            { text: item.date },
            { text: item.txn_number },
            { text: item.description },
            { text: commaFormat(item.points_earned), alignment: 'right' },
            { text: commaFormat(item.points_redeemed), alignment: 'right' },
            { text: commaFormat(item.balance), alignment: 'right' },
        ]
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
